import { render } from "./NewTariff.vue?vue&type=template&id=6ea54a89&scoped=true"
import script from "./NewTariff.vue?vue&type=script&lang=js"
export * from "./NewTariff.vue?vue&type=script&lang=js"

import "./NewTariff.vue?vue&type=style&index=0&id=6ea54a89&scoped=true&lang=css"

import exportComponent from "C:\\Askar\\personalArea\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ea54a89"]])

export default __exports__